"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.speechSynthesis = exports.SpeechSynthesisVoice = exports.SpeechSynthesisUtterance = exports.SpeechSynthesisEvent = void 0;

var _es = _interopRequireWildcard(require("event-target-shim/es5"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var SpeechSynthesisEvent = /*#__PURE__*/function (_Event) {
  _inherits(SpeechSynthesisEvent, _Event);

  var _super = _createSuper(SpeechSynthesisEvent);

  function SpeechSynthesisEvent(type, utterance) {
    var _this;

    _classCallCheck(this, SpeechSynthesisEvent);

    _this = _super.call(this, type);
    _this._utterance = utterance;
    return _this;
  }

  _createClass(SpeechSynthesisEvent, [{
    key: "charIndex",
    get: function get() {
      return 0;
    }
  }, {
    key: "elapsedTime",
    get: function get() {
      return 0;
    }
  }, {
    key: "name",
    get: function get() {// It is expected to return `undefined`, keeping the function empty to reduce footprint.
    }
  }, {
    key: "utterance",
    get: function get() {
      return this._utterance;
    }
  }]);

  return SpeechSynthesisEvent;
}(_es.Event);

exports.SpeechSynthesisEvent = SpeechSynthesisEvent;

var SpeechSynthesisUtterance = /*#__PURE__*/function (_EventTarget) {
  _inherits(SpeechSynthesisUtterance, _EventTarget);

  var _super2 = _createSuper(SpeechSynthesisUtterance);

  function SpeechSynthesisUtterance(text) {
    var _this2;

    _classCallCheck(this, SpeechSynthesisUtterance);

    _this2 = _super2.call(this);
    _this2._lang = 'en-US';
    _this2._pitch = 1;
    _this2._rate = 1;
    _this2._text = text;
    _this2._voice = null;
    _this2._volume = 1;
    return _this2;
  }

  _createClass(SpeechSynthesisUtterance, [{
    key: "lang",
    get: function get() {
      return this._lang;
    },
    set: function set(value) {
      this._lang = value;
    }
  }, {
    key: "pitch",
    get: function get() {
      return this._pitch;
    },
    set: function set(value) {
      this._pitch = value;
    }
  }, {
    key: "rate",
    get: function get() {
      return this._rate;
    },
    set: function set(value) {
      this._rate = value;
    }
  }, {
    key: "text",
    get: function get() {
      return this._text;
    },
    set: function set(value) {
      this._text = value;
    }
  }, {
    key: "voice",
    get: function get() {
      return this._voice;
    },
    set: function set(value) {
      this._voice = value;
    }
  }, {
    key: "volume",
    get: function get() {
      return this._volume;
    },
    set: function set(value) {
      this._volume = value;
    }
  }, {
    key: "onboundary",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'boundary');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'boundary', value);
    }
  }, {
    key: "onend",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'end');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'end', value);
    }
  }, {
    key: "onerror",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'error');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'error', value);
    }
  }, {
    key: "onmark",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'mark');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'mark', value);
    }
  }, {
    key: "onpause",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'pause');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'pause', value);
    }
  }, {
    key: "onresume",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'resume');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'resume', value);
    }
  }, {
    key: "onstart",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'start');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'start', value);
    }
  }]);

  return SpeechSynthesisUtterance;
}(_es.default);

exports.SpeechSynthesisUtterance = SpeechSynthesisUtterance;

var SpeechSynthesisVoice = /*#__PURE__*/function () {
  function SpeechSynthesisVoice() {
    _classCallCheck(this, SpeechSynthesisVoice);
  }

  _createClass(SpeechSynthesisVoice, [{
    key: "default",
    get: function get() {
      return true;
    }
  }, {
    key: "lang",
    get: function get() {
      return 'en-US';
    }
  }, {
    key: "localService",
    get: function get() {
      return true;
    }
  }, {
    key: "name",
    get: function get() {
      return 'English (US)';
    }
  }, {
    key: "voiceURI",
    get: function get() {
      return 'English (US)';
    }
  }]);

  return SpeechSynthesisVoice;
}();

exports.SpeechSynthesisVoice = SpeechSynthesisVoice;

var SpeechSynthesis = /*#__PURE__*/function (_EventTarget2) {
  _inherits(SpeechSynthesis, _EventTarget2);

  var _super3 = _createSuper(SpeechSynthesis);

  function SpeechSynthesis() {
    _classCallCheck(this, SpeechSynthesis);

    return _super3.apply(this, arguments);
  }

  _createClass(SpeechSynthesis, [{
    key: "paused",
    get: function get() {
      return false;
    }
  }, {
    key: "pending",
    get: function get() {
      return false;
    }
  }, {
    key: "speaking",
    get: function get() {
      return false;
    }
  }, {
    key: "cancel",
    value: function cancel() {}
  }, {
    key: "getVoices",
    value: function getVoices() {
      return [new SpeechSynthesisVoice()];
    }
  }, {
    key: "pause",
    value: function pause() {
      throw new Error('pause is not implemented.');
    }
  }, {
    key: "resume",
    value: function resume() {
      throw new Error('resume is not implemented.');
    }
  }, {
    key: "speak",
    value: function speak(utterance) {
      utterance.dispatchEvent(new SpeechSynthesisEvent('start', utterance));
      utterance.dispatchEvent(new SpeechSynthesisEvent('end', utterance));
    }
  }, {
    key: "onvoiceschanged",
    get: function get() {
      return (0, _es.getEventAttributeValue)(this, 'voiceschanged');
    },
    set: function set(value) {
      (0, _es.setEventAttributeValue)(this, 'voiceschanged', value);
    }
  }]);

  return SpeechSynthesis;
}(_es.default);

var speechSynthesis = new SpeechSynthesis();
exports.speechSynthesis = speechSynthesis;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTcGVlY2hTeW50aGVzaXNFdmVudCIsInR5cGUiLCJ1dHRlcmFuY2UiLCJfdXR0ZXJhbmNlIiwiRXZlbnQiLCJTcGVlY2hTeW50aGVzaXNVdHRlcmFuY2UiLCJ0ZXh0IiwiX2xhbmciLCJfcGl0Y2giLCJfcmF0ZSIsIl90ZXh0IiwiX3ZvaWNlIiwiX3ZvbHVtZSIsInZhbHVlIiwiZ2V0RXZlbnRBdHRyaWJ1dGVWYWx1ZSIsInNldEV2ZW50QXR0cmlidXRlVmFsdWUiLCJFdmVudFRhcmdldCIsIlNwZWVjaFN5bnRoZXNpc1ZvaWNlIiwiU3BlZWNoU3ludGhlc2lzIiwiRXJyb3IiLCJkaXNwYXRjaEV2ZW50Iiwic3BlZWNoU3ludGhlc2lzIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvaG9va3MvaW50ZXJuYWwvQnlwYXNzU3BlZWNoU3ludGhlc2lzUG9ueWZpbGwuanMiXSwic291cmNlc0NvbnRlbnQiOlsiLy8gU2luY2UgdGhpcyBpcyBhIGJ5cGFzcywgd2Ugd2lsbCByZWxheCBzb21lIEVTTGludCBydWxlcy5cbi8vIEFsbCBjbGFzc2VzL3Byb3BlcnRpZXMgZGVmaW5lZCBoZXJlIGFyZSBpbiBXM0MgV2ViIFNwZWVjaCBBUEkuXG5cbi8qIGVzbGludCBjbGFzcy1tZXRob2RzLXVzZS10aGlzOiBcIm9mZlwiICovXG4vKiBlc2xpbnQgZ2V0dGVyLXJldHVybjogXCJvZmZcIiAqL1xuLyogZXNsaW50IG1heC1jbGFzc2VzLXBlci1maWxlOiBbXCJlcnJvclwiLCA0XSAqL1xuLyogZXNsaW50IG5vLWVtcHR5LWZ1bmN0aW9uOiBcIm9mZlwiICovXG5cbmltcG9ydCBFdmVudFRhcmdldCwgeyBFdmVudCwgZ2V0RXZlbnRBdHRyaWJ1dGVWYWx1ZSwgc2V0RXZlbnRBdHRyaWJ1dGVWYWx1ZSB9IGZyb20gJ2V2ZW50LXRhcmdldC1zaGltL2VzNSc7XG5cbmNsYXNzIFNwZWVjaFN5bnRoZXNpc0V2ZW50IGV4dGVuZHMgRXZlbnQge1xuICBjb25zdHJ1Y3Rvcih0eXBlLCB1dHRlcmFuY2UpIHtcbiAgICBzdXBlcih0eXBlKTtcblxuICAgIHRoaXMuX3V0dGVyYW5jZSA9IHV0dGVyYW5jZTtcbiAgfVxuXG4gIGdldCBjaGFySW5kZXgoKSB7XG4gICAgcmV0dXJuIDA7XG4gIH1cblxuICBnZXQgZWxhcHNlZFRpbWUoKSB7XG4gICAgcmV0dXJuIDA7XG4gIH1cblxuICBnZXQgbmFtZSgpIHtcbiAgICAvLyBJdCBpcyBleHBlY3RlZCB0byByZXR1cm4gYHVuZGVmaW5lZGAsIGtlZXBpbmcgdGhlIGZ1bmN0aW9uIGVtcHR5IHRvIHJlZHVjZSBmb290cHJpbnQuXG4gIH1cblxuICBnZXQgdXR0ZXJhbmNlKCkge1xuICAgIHJldHVybiB0aGlzLl91dHRlcmFuY2U7XG4gIH1cbn1cblxuY2xhc3MgU3BlZWNoU3ludGhlc2lzVXR0ZXJhbmNlIGV4dGVuZHMgRXZlbnRUYXJnZXQge1xuICBjb25zdHJ1Y3Rvcih0ZXh0KSB7XG4gICAgc3VwZXIoKTtcblxuICAgIHRoaXMuX2xhbmcgPSAnZW4tVVMnO1xuICAgIHRoaXMuX3BpdGNoID0gMTtcbiAgICB0aGlzLl9yYXRlID0gMTtcbiAgICB0aGlzLl90ZXh0ID0gdGV4dDtcbiAgICB0aGlzLl92b2ljZSA9IG51bGw7XG4gICAgdGhpcy5fdm9sdW1lID0gMTtcbiAgfVxuXG4gIGdldCBsYW5nKCkge1xuICAgIHJldHVybiB0aGlzLl9sYW5nO1xuICB9XG5cbiAgc2V0IGxhbmcodmFsdWUpIHtcbiAgICB0aGlzLl9sYW5nID0gdmFsdWU7XG4gIH1cblxuICBnZXQgcGl0Y2goKSB7XG4gICAgcmV0dXJuIHRoaXMuX3BpdGNoO1xuICB9XG5cbiAgc2V0IHBpdGNoKHZhbHVlKSB7XG4gICAgdGhpcy5fcGl0Y2ggPSB2YWx1ZTtcbiAgfVxuXG4gIGdldCByYXRlKCkge1xuICAgIHJldHVybiB0aGlzLl9yYXRlO1xuICB9XG5cbiAgc2V0IHJhdGUodmFsdWUpIHtcbiAgICB0aGlzLl9yYXRlID0gdmFsdWU7XG4gIH1cblxuICBnZXQgdGV4dCgpIHtcbiAgICByZXR1cm4gdGhpcy5fdGV4dDtcbiAgfVxuXG4gIHNldCB0ZXh0KHZhbHVlKSB7XG4gICAgdGhpcy5fdGV4dCA9IHZhbHVlO1xuICB9XG5cbiAgZ2V0IHZvaWNlKCkge1xuICAgIHJldHVybiB0aGlzLl92b2ljZTtcbiAgfVxuXG4gIHNldCB2b2ljZSh2YWx1ZSkge1xuICAgIHRoaXMuX3ZvaWNlID0gdmFsdWU7XG4gIH1cblxuICBnZXQgdm9sdW1lKCkge1xuICAgIHJldHVybiB0aGlzLl92b2x1bWU7XG4gIH1cblxuICBzZXQgdm9sdW1lKHZhbHVlKSB7XG4gICAgdGhpcy5fdm9sdW1lID0gdmFsdWU7XG4gIH1cblxuICBnZXQgb25ib3VuZGFyeSgpIHtcbiAgICByZXR1cm4gZ2V0RXZlbnRBdHRyaWJ1dGVWYWx1ZSh0aGlzLCAnYm91bmRhcnknKTtcbiAgfVxuXG4gIHNldCBvbmJvdW5kYXJ5KHZhbHVlKSB7XG4gICAgc2V0RXZlbnRBdHRyaWJ1dGVWYWx1ZSh0aGlzLCAnYm91bmRhcnknLCB2YWx1ZSk7XG4gIH1cblxuICBnZXQgb25lbmQoKSB7XG4gICAgcmV0dXJuIGdldEV2ZW50QXR0cmlidXRlVmFsdWUodGhpcywgJ2VuZCcpO1xuICB9XG5cbiAgc2V0IG9uZW5kKHZhbHVlKSB7XG4gICAgc2V0RXZlbnRBdHRyaWJ1dGVWYWx1ZSh0aGlzLCAnZW5kJywgdmFsdWUpO1xuICB9XG5cbiAgZ2V0IG9uZXJyb3IoKSB7XG4gICAgcmV0dXJuIGdldEV2ZW50QXR0cmlidXRlVmFsdWUodGhpcywgJ2Vycm9yJyk7XG4gIH1cblxuICBzZXQgb25lcnJvcih2YWx1ZSkge1xuICAgIHNldEV2ZW50QXR0cmlidXRlVmFsdWUodGhpcywgJ2Vycm9yJywgdmFsdWUpO1xuICB9XG5cbiAgZ2V0IG9ubWFyaygpIHtcbiAgICByZXR1cm4gZ2V0RXZlbnRBdHRyaWJ1dGVWYWx1ZSh0aGlzLCAnbWFyaycpO1xuICB9XG5cbiAgc2V0IG9ubWFyayh2YWx1ZSkge1xuICAgIHNldEV2ZW50QXR0cmlidXRlVmFsdWUodGhpcywgJ21hcmsnLCB2YWx1ZSk7XG4gIH1cblxuICBnZXQgb25wYXVzZSgpIHtcbiAgICByZXR1cm4gZ2V0RXZlbnRBdHRyaWJ1dGVWYWx1ZSh0aGlzLCAncGF1c2UnKTtcbiAgfVxuXG4gIHNldCBvbnBhdXNlKHZhbHVlKSB7XG4gICAgc2V0RXZlbnRBdHRyaWJ1dGVWYWx1ZSh0aGlzLCAncGF1c2UnLCB2YWx1ZSk7XG4gIH1cblxuICBnZXQgb25yZXN1bWUoKSB7XG4gICAgcmV0dXJuIGdldEV2ZW50QXR0cmlidXRlVmFsdWUodGhpcywgJ3Jlc3VtZScpO1xuICB9XG5cbiAgc2V0IG9ucmVzdW1lKHZhbHVlKSB7XG4gICAgc2V0RXZlbnRBdHRyaWJ1dGVWYWx1ZSh0aGlzLCAncmVzdW1lJywgdmFsdWUpO1xuICB9XG5cbiAgZ2V0IG9uc3RhcnQoKSB7XG4gICAgcmV0dXJuIGdldEV2ZW50QXR0cmlidXRlVmFsdWUodGhpcywgJ3N0YXJ0Jyk7XG4gIH1cblxuICBzZXQgb25zdGFydCh2YWx1ZSkge1xuICAgIHNldEV2ZW50QXR0cmlidXRlVmFsdWUodGhpcywgJ3N0YXJ0JywgdmFsdWUpO1xuICB9XG59XG5cbmNsYXNzIFNwZWVjaFN5bnRoZXNpc1ZvaWNlIHtcbiAgZ2V0IGRlZmF1bHQoKSB7XG4gICAgcmV0dXJuIHRydWU7XG4gIH1cblxuICBnZXQgbGFuZygpIHtcbiAgICByZXR1cm4gJ2VuLVVTJztcbiAgfVxuXG4gIGdldCBsb2NhbFNlcnZpY2UoKSB7XG4gICAgcmV0dXJuIHRydWU7XG4gIH1cblxuICBnZXQgbmFtZSgpIHtcbiAgICByZXR1cm4gJ0VuZ2xpc2ggKFVTKSc7XG4gIH1cblxuICBnZXQgdm9pY2VVUkkoKSB7XG4gICAgcmV0dXJuICdFbmdsaXNoIChVUyknO1xuICB9XG59XG5cbmNsYXNzIFNwZWVjaFN5bnRoZXNpcyBleHRlbmRzIEV2ZW50VGFyZ2V0IHtcbiAgZ2V0IHBhdXNlZCgpIHtcbiAgICByZXR1cm4gZmFsc2U7XG4gIH1cblxuICBnZXQgcGVuZGluZygpIHtcbiAgICByZXR1cm4gZmFsc2U7XG4gIH1cblxuICBnZXQgc3BlYWtpbmcoKSB7XG4gICAgcmV0dXJuIGZhbHNlO1xuICB9XG5cbiAgY2FuY2VsKCkge31cblxuICBnZXRWb2ljZXMoKSB7XG4gICAgcmV0dXJuIFtuZXcgU3BlZWNoU3ludGhlc2lzVm9pY2UoKV07XG4gIH1cblxuICBwYXVzZSgpIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoJ3BhdXNlIGlzIG5vdCBpbXBsZW1lbnRlZC4nKTtcbiAgfVxuXG4gIHJlc3VtZSgpIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoJ3Jlc3VtZSBpcyBub3QgaW1wbGVtZW50ZWQuJyk7XG4gIH1cblxuICBzcGVhayh1dHRlcmFuY2UpIHtcbiAgICB1dHRlcmFuY2UuZGlzcGF0Y2hFdmVudChuZXcgU3BlZWNoU3ludGhlc2lzRXZlbnQoJ3N0YXJ0JywgdXR0ZXJhbmNlKSk7XG4gICAgdXR0ZXJhbmNlLmRpc3BhdGNoRXZlbnQobmV3IFNwZWVjaFN5bnRoZXNpc0V2ZW50KCdlbmQnLCB1dHRlcmFuY2UpKTtcbiAgfVxuXG4gIGdldCBvbnZvaWNlc2NoYW5nZWQoKSB7XG4gICAgcmV0dXJuIGdldEV2ZW50QXR0cmlidXRlVmFsdWUodGhpcywgJ3ZvaWNlc2NoYW5nZWQnKTtcbiAgfVxuXG4gIHNldCBvbnZvaWNlc2NoYW5nZWQodmFsdWUpIHtcbiAgICBzZXRFdmVudEF0dHJpYnV0ZVZhbHVlKHRoaXMsICd2b2ljZXNjaGFuZ2VkJywgdmFsdWUpO1xuICB9XG59XG5cbmNvbnN0IHNwZWVjaFN5bnRoZXNpcyA9IG5ldyBTcGVlY2hTeW50aGVzaXMoKTtcblxuZXhwb3J0IHsgc3BlZWNoU3ludGhlc2lzLCBTcGVlY2hTeW50aGVzaXNFdmVudCwgU3BlZWNoU3ludGhlc2lzVXR0ZXJhbmNlLCBTcGVlY2hTeW50aGVzaXNWb2ljZSB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFRQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFFTUEsb0I7Ozs7O0VBQ0osOEJBQVlDLElBQVosRUFBa0JDLFNBQWxCLEVBQTZCO0lBQUE7O0lBQUE7O0lBQzNCLDBCQUFNRCxJQUFOO0lBRUEsTUFBS0UsVUFBTCxHQUFrQkQsU0FBbEI7SUFIMkI7RUFJNUI7Ozs7U0FFRCxlQUFnQjtNQUNkLE9BQU8sQ0FBUDtJQUNEOzs7U0FFRCxlQUFrQjtNQUNoQixPQUFPLENBQVA7SUFDRDs7O1NBRUQsZUFBVyxDQUNUO0lBQ0Q7OztTQUVELGVBQWdCO01BQ2QsT0FBTyxLQUFLQyxVQUFaO0lBQ0Q7Ozs7RUFyQmdDQyxTOzs7O0lBd0I3QkMsd0I7Ozs7O0VBQ0osa0NBQVlDLElBQVosRUFBa0I7SUFBQTs7SUFBQTs7SUFDaEI7SUFFQSxPQUFLQyxLQUFMLEdBQWEsT0FBYjtJQUNBLE9BQUtDLE1BQUwsR0FBYyxDQUFkO0lBQ0EsT0FBS0MsS0FBTCxHQUFhLENBQWI7SUFDQSxPQUFLQyxLQUFMLEdBQWFKLElBQWI7SUFDQSxPQUFLSyxNQUFMLEdBQWMsSUFBZDtJQUNBLE9BQUtDLE9BQUwsR0FBZSxDQUFmO0lBUmdCO0VBU2pCOzs7O1NBRUQsZUFBVztNQUNULE9BQU8sS0FBS0wsS0FBWjtJQUNELEM7U0FFRCxhQUFTTSxLQUFULEVBQWdCO01BQ2QsS0FBS04sS0FBTCxHQUFhTSxLQUFiO0lBQ0Q7OztTQUVELGVBQVk7TUFDVixPQUFPLEtBQUtMLE1BQVo7SUFDRCxDO1NBRUQsYUFBVUssS0FBVixFQUFpQjtNQUNmLEtBQUtMLE1BQUwsR0FBY0ssS0FBZDtJQUNEOzs7U0FFRCxlQUFXO01BQ1QsT0FBTyxLQUFLSixLQUFaO0lBQ0QsQztTQUVELGFBQVNJLEtBQVQsRUFBZ0I7TUFDZCxLQUFLSixLQUFMLEdBQWFJLEtBQWI7SUFDRDs7O1NBRUQsZUFBVztNQUNULE9BQU8sS0FBS0gsS0FBWjtJQUNELEM7U0FFRCxhQUFTRyxLQUFULEVBQWdCO01BQ2QsS0FBS0gsS0FBTCxHQUFhRyxLQUFiO0lBQ0Q7OztTQUVELGVBQVk7TUFDVixPQUFPLEtBQUtGLE1BQVo7SUFDRCxDO1NBRUQsYUFBVUUsS0FBVixFQUFpQjtNQUNmLEtBQUtGLE1BQUwsR0FBY0UsS0FBZDtJQUNEOzs7U0FFRCxlQUFhO01BQ1gsT0FBTyxLQUFLRCxPQUFaO0lBQ0QsQztTQUVELGFBQVdDLEtBQVgsRUFBa0I7TUFDaEIsS0FBS0QsT0FBTCxHQUFlQyxLQUFmO0lBQ0Q7OztTQUVELGVBQWlCO01BQ2YsT0FBTyxJQUFBQywwQkFBQSxFQUF1QixJQUF2QixFQUE2QixVQUE3QixDQUFQO0lBQ0QsQztTQUVELGFBQWVELEtBQWYsRUFBc0I7TUFDcEIsSUFBQUUsMEJBQUEsRUFBdUIsSUFBdkIsRUFBNkIsVUFBN0IsRUFBeUNGLEtBQXpDO0lBQ0Q7OztTQUVELGVBQVk7TUFDVixPQUFPLElBQUFDLDBCQUFBLEVBQXVCLElBQXZCLEVBQTZCLEtBQTdCLENBQVA7SUFDRCxDO1NBRUQsYUFBVUQsS0FBVixFQUFpQjtNQUNmLElBQUFFLDBCQUFBLEVBQXVCLElBQXZCLEVBQTZCLEtBQTdCLEVBQW9DRixLQUFwQztJQUNEOzs7U0FFRCxlQUFjO01BQ1osT0FBTyxJQUFBQywwQkFBQSxFQUF1QixJQUF2QixFQUE2QixPQUE3QixDQUFQO0lBQ0QsQztTQUVELGFBQVlELEtBQVosRUFBbUI7TUFDakIsSUFBQUUsMEJBQUEsRUFBdUIsSUFBdkIsRUFBNkIsT0FBN0IsRUFBc0NGLEtBQXRDO0lBQ0Q7OztTQUVELGVBQWE7TUFDWCxPQUFPLElBQUFDLDBCQUFBLEVBQXVCLElBQXZCLEVBQTZCLE1BQTdCLENBQVA7SUFDRCxDO1NBRUQsYUFBV0QsS0FBWCxFQUFrQjtNQUNoQixJQUFBRSwwQkFBQSxFQUF1QixJQUF2QixFQUE2QixNQUE3QixFQUFxQ0YsS0FBckM7SUFDRDs7O1NBRUQsZUFBYztNQUNaLE9BQU8sSUFBQUMsMEJBQUEsRUFBdUIsSUFBdkIsRUFBNkIsT0FBN0IsQ0FBUDtJQUNELEM7U0FFRCxhQUFZRCxLQUFaLEVBQW1CO01BQ2pCLElBQUFFLDBCQUFBLEVBQXVCLElBQXZCLEVBQTZCLE9BQTdCLEVBQXNDRixLQUF0QztJQUNEOzs7U0FFRCxlQUFlO01BQ2IsT0FBTyxJQUFBQywwQkFBQSxFQUF1QixJQUF2QixFQUE2QixRQUE3QixDQUFQO0lBQ0QsQztTQUVELGFBQWFELEtBQWIsRUFBb0I7TUFDbEIsSUFBQUUsMEJBQUEsRUFBdUIsSUFBdkIsRUFBNkIsUUFBN0IsRUFBdUNGLEtBQXZDO0lBQ0Q7OztTQUVELGVBQWM7TUFDWixPQUFPLElBQUFDLDBCQUFBLEVBQXVCLElBQXZCLEVBQTZCLE9BQTdCLENBQVA7SUFDRCxDO1NBRUQsYUFBWUQsS0FBWixFQUFtQjtNQUNqQixJQUFBRSwwQkFBQSxFQUF1QixJQUF2QixFQUE2QixPQUE3QixFQUFzQ0YsS0FBdEM7SUFDRDs7OztFQWxIb0NHLFc7Ozs7SUFxSGpDQyxvQjs7Ozs7OztTQUNKLGVBQWM7TUFDWixPQUFPLElBQVA7SUFDRDs7O1NBRUQsZUFBVztNQUNULE9BQU8sT0FBUDtJQUNEOzs7U0FFRCxlQUFtQjtNQUNqQixPQUFPLElBQVA7SUFDRDs7O1NBRUQsZUFBVztNQUNULE9BQU8sY0FBUDtJQUNEOzs7U0FFRCxlQUFlO01BQ2IsT0FBTyxjQUFQO0lBQ0Q7Ozs7Ozs7O0lBR0dDLGU7Ozs7Ozs7Ozs7Ozs7U0FDSixlQUFhO01BQ1gsT0FBTyxLQUFQO0lBQ0Q7OztTQUVELGVBQWM7TUFDWixPQUFPLEtBQVA7SUFDRDs7O1NBRUQsZUFBZTtNQUNiLE9BQU8sS0FBUDtJQUNEOzs7V0FFRCxrQkFBUyxDQUFFOzs7V0FFWCxxQkFBWTtNQUNWLE9BQU8sQ0FBQyxJQUFJRCxvQkFBSixFQUFELENBQVA7SUFDRDs7O1dBRUQsaUJBQVE7TUFDTixNQUFNLElBQUlFLEtBQUosQ0FBVSwyQkFBVixDQUFOO0lBQ0Q7OztXQUVELGtCQUFTO01BQ1AsTUFBTSxJQUFJQSxLQUFKLENBQVUsNEJBQVYsQ0FBTjtJQUNEOzs7V0FFRCxlQUFNakIsU0FBTixFQUFpQjtNQUNmQSxTQUFTLENBQUNrQixhQUFWLENBQXdCLElBQUlwQixvQkFBSixDQUF5QixPQUF6QixFQUFrQ0UsU0FBbEMsQ0FBeEI7TUFDQUEsU0FBUyxDQUFDa0IsYUFBVixDQUF3QixJQUFJcEIsb0JBQUosQ0FBeUIsS0FBekIsRUFBZ0NFLFNBQWhDLENBQXhCO0lBQ0Q7OztTQUVELGVBQXNCO01BQ3BCLE9BQU8sSUFBQVksMEJBQUEsRUFBdUIsSUFBdkIsRUFBNkIsZUFBN0IsQ0FBUDtJQUNELEM7U0FFRCxhQUFvQkQsS0FBcEIsRUFBMkI7TUFDekIsSUFBQUUsMEJBQUEsRUFBdUIsSUFBdkIsRUFBNkIsZUFBN0IsRUFBOENGLEtBQTlDO0lBQ0Q7Ozs7RUF0QzJCRyxXOztBQXlDOUIsSUFBTUssZUFBZSxHQUFHLElBQUlILGVBQUosRUFBeEIifQ==